import styled, { css } from 'styled-components';

export const HeyGenAvatarVideo = styled.video`
  width: 100%;
  height: 100%;
`;

export const ReconnectWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: { color } }) =>
    css`
      ${color.midnight}
    `};
`;
